module.exports = __webpack_public_path__ + "static/drawing-5-a387920a1e0f485a5058dde26913bbee.svg";